import {
    apiRequest,
    kursusList,
    kursusInactive,
    kursusActive,
    kursusDetail
} from "../../../../../../services/adapters/kepegawaian/kursusService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", kursusList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", kursusInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", kursusActive, {
            body: query
        }, true)
    }

    fetchDetail = async (query, cancelToken) => {
        return await apiRequest("get", kursusDetail, {
            params: query,
            cancelToken: cancelToken
        }, true)
    }

}

export default DataTableRepository